import React from "react";
import PropTypes from "prop-types";
import RegularSeasonKpiCards from "./RegularSeasonKpiCards";

const RegularSeasonKpiEventCards = (props) => <RegularSeasonKpiCards {...props} />;

RegularSeasonKpiEventCards.propTypes = {
  kpis: PropTypes.array.isRequired,
};

export default RegularSeasonKpiEventCards;
